import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import LeadDialog from "@/components/landing/LeadDialog";

const DELAY_MS = 20_000;
const SESSION_KEY = "utsah_popup_shown";
// Routes where the popup is intentionally suppressed
const EXCLUDED_PATHS = ["/thank-you", "/admin", "/diwali-catalogue"];

/**
 * Site-wide "Speak to a Gift Advisor" popup.
 *  - Fires 20 seconds after the visitor lands on any public page.
 *  - Only opens once per browser session (sessionStorage flag).
 *  - Skips if an existing LeadDialog is already visible.
 *  - Skips on /thank-you (post-submit) and /admin/* and /diwali-catalogue (immersive).
 *  - Uses the existing LeadDialog + submitLead pipeline — no separate form
 *    or database wiring. Submissions redirect to /thank-you exactly like
 *    every other enquiry form.
 */
export default function GlobalEnquiryPopup() {
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const isExcluded = EXCLUDED_PATHS.some((p) => location.pathname.startsWith(p));

  useEffect(() => {
    if (isExcluded) return;
    // Already shown this session
    try {
      if (window.sessionStorage.getItem(SESSION_KEY) === "1") return;
    } catch {}

    const timer = window.setTimeout(() => {
      // Don't overlap an existing lead form
      const existing = document.querySelector('[data-testid="lead-dialog"]');
      if (existing) return;
      try { window.sessionStorage.setItem(SESSION_KEY, "1"); } catch {}
      setOpen(true);
    }, DELAY_MS);

    return () => window.clearTimeout(timer);
  }, [isExcluded, location.pathname]);

  if (isExcluded) return null;

  return (
    <LeadDialog
      open={open}
      type="advisor"
      source="Site-wide Popup (20s)"
      onOpenChange={(v) => setOpen(v)}
    />
  );
}
